import { useState } from 'react';
import { Phone, RectangleHorizontal, Car, Building2, ShoppingBag, Store, Plane, Briefcase, HandCoins, Link2, ArrowUpLeft, ArrowUpRight } from 'lucide-react';
import { PriceDisplay } from '../PriceDisplay';
import { mediaUrl } from '../../utils/searchClient';

export const ICONS = { phone: Phone, plate: RectangleHorizontal, car: Car, home: Building2, bag: ShoppingBag, store: Store, plane: Plane, building: Briefcase, hand: HandCoins, link: Link2 };

const SHOW_PRICE = new Set(['numbers', 'plates', 'cars', 'real_estate', 'products', 'services']);

export const ResultThumb = ({ item, isDarkMode, size = 'h-11 w-11' }) => {
  const [failed, setFailed] = useState(false);
  const Icon = ICONS[item.icon] || Link2;
  if (item.image && !failed) {
    return (
      <img src={mediaUrl(item.image)} alt="" loading="lazy" onError={() => setFailed(true)}
        className={`${size} rounded-xl object-cover shrink-0 border ${isDarkMode ? 'border-white/10 bg-white/5' : 'border-slate-200 bg-slate-100'}`} />
    );
  }
  return (
    <span className={`${size} rounded-xl shrink-0 flex items-center justify-center border ${isDarkMode ? 'bg-[#1E9BD9]/10 border-[#1E9BD9]/20' : 'bg-[#1E9BD9]/[0.07] border-[#1E9BD9]/20'}`}>
      <Icon className="h-5 w-5 text-[#1E9BD9]" />
    </span>
  );
};

export const ResultPrice = ({ item }) => {
  if (!SHOW_PRICE.has(item.section)) return null;
  if (item.section === 'services' && !item.price) return null;
  return <PriceDisplay price={item.sale_price || (item.price_on_request ? null : item.price)} size="sm" />;
};

/** Compact row used in the header dropdown / mobile overlay. */
export const SearchResultRow = ({ item, active, isAr, isDarkMode, onSelect, testId }) => {
  const Arrow = isAr ? ArrowUpLeft : ArrowUpRight;
  return (
    <button
      type="button"
      onMouseDown={(e) => e.preventDefault()}
      onClick={onSelect}
      data-testid={testId}
      className={`group w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-start transition-colors duration-150 ${
        active ? (isDarkMode ? 'bg-[#1E9BD9]/15' : 'bg-[#1E9BD9]/10') : (isDarkMode ? 'hover:bg-white/5' : 'hover:bg-slate-100')
      }`}
    >
      <ResultThumb item={item} isDarkMode={isDarkMode} />
      <span className="min-w-0 flex-1">
        <span className={`block truncate text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-slate-900'}`} dir="auto">
          {isAr ? item.title_ar : item.title_en}
        </span>
        <span className={`block truncate text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`} dir="auto">
          {isAr ? item.subtitle_ar : item.subtitle_en}
        </span>
      </span>
      <span className="shrink-0 hidden sm:block"><ResultPrice item={item} /></span>
      <Arrow className={`h-4 w-4 shrink-0 transition-transform duration-150 group-hover:-translate-y-0.5 ${active ? 'text-[#1E9BD9]' : (isDarkMode ? 'text-slate-600' : 'text-slate-300')}`} />
    </button>
  );
};
